module.exports = __webpack_public_path__ + "img/me.d8e4f69a.svg";